import { useEffect } from 'react';

import { DEFAULT_SERVICE_TITLE, SERVICE_TYPE_BY_NAME_MAPPING } from '~/common/constants/search';
import { useContextualLinksDispatch } from '~/components/PlatformFooter/PlatformFooterContextualLinks/context';

import type { SearchFilters, SearchLink } from '~/common/types/search';
import type { ContextualLinks } from '~/components/PlatformFooter/PlatformFooterContextualLinks/types';

const createContextualLinks = (
  nearbySuburbsLinks: SearchLink[] | undefined,
  relatedSearchesLinks: SearchLink[] | null,
  searchFilters: SearchFilters,
  serviceSlug: string
): ContextualLinks[] => {
  const contextualLinks: ContextualLinks[] = [];

  if (nearbySuburbsLinks) {
    const { location } = searchFilters;
    const serviceTitle =
      SERVICE_TYPE_BY_NAME_MAPPING[serviceSlug]?.serviceTitle || DEFAULT_SERVICE_TITLE;
    const searchedSuburb = location.address.suburb;

    contextualLinks.push({
      heading: `${serviceTitle} Neighbourhoods near ${searchedSuburb}`,
      links: nearbySuburbsLinks.map(({ href, label }) => ({ href, label })),
    });
  }

  if (relatedSearchesLinks) {
    contextualLinks.push({
      heading: 'Related Searches',
      links: relatedSearchesLinks.map(({ href, label }) => ({ href, label })),
    });
  }

  return contextualLinks;
};

const useUpdateContextualLinks = (
  nearbySuburbsLinks: SearchLink[] | undefined,
  relatedSearchesLinks: SearchLink[] | null,
  searchFilters: SearchFilters,
  serviceSlug: string
): void => {
  const dispatchContextualLinks = useContextualLinksDispatch();

  useEffect(() => {
    const contextualLinks = createContextualLinks(
      nearbySuburbsLinks,
      relatedSearchesLinks,
      searchFilters,
      serviceSlug
    );

    dispatchContextualLinks(contextualLinks);
  });
};

export { useUpdateContextualLinks };
